<template>
  <div>
    <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5 pb-10">
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ดอกเบี้ยตามฟ้อง</label>
          <vs-input type="number" class="input w-1/2" v-model="restructuringInterest.interestAsPerLawsuit"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ดอกเบี้ยคิดถึงวันฟ้อง</label>
          <vs-input type="number" class="input w-1/2" v-model="restructuringInterest.interestUntilLawsuitDate"/>
        </div>
      </div>

      <div class="flex gap-4">
        <vs-table :data="[{}]">
          <!-- thead -->
          <template slot="thead">
            <vs-th class="text-center">จากวันที่</vs-th>
            <vs-th class="text-center">ถึงวันที่</vs-th>
            <vs-th class="text-center">จำนวนวัน</vs-th>
            <vs-th class="text-center">อัตราดอกเบี้ย (%)</vs-th>
            <vs-th class="text-center">เงินต้น</vs-th>
            <vs-th class="text-center">ดอกเบี้ยถัดจากวันฟ้อง</vs-th>
          </template>

          <!-- tr -->
          <template slot-scope="{data}">
            <vs-tr>
              <vs-td>
                <flat-pickr :config="configDue" class="input w-full" v-model="startDate"/>
              </vs-td>
              <vs-td>
                <flat-pickr :config="configDue" class="input w-full" v-model="endDate"/>
              </vs-td>
              <vs-td>
                <vs-input type="number" v-model="numDays" class="input w-full" disabled="disabled"/>
              </vs-td>
              <vs-td>
                <vs-input type="number" v-model="interestRate" class="input w-full"/>
              </vs-td>
              <vs-td>
                <vs-input type="number" v-model="principalAmount" class="input w-full"/>
              </vs-td>
              <vs-td>
                <vs-input type="number" v-model="restructuringInterest.interestAfterLawsuitDate" class="input w-full" disabled="disabled"/>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>


  </div>
</template>

<script>/**
 * @typedef {Object} RestructuringInterest
 * @property {number} interestAsPerLawsuit ดอกเบี้ยตามฟ้อง
 * @property {number} interestUntilLawsuitDate ดอกเบี้ยคิดถึงวันฟ้อง
 * @property {number} interestAfterLawsuitDate ดอกเบี้ยถัดจากวันฟ้อง
 */
import {Thai} from "flatpickr/dist/l10n/th";
import 'flatpickr/dist/themes/dark.css'
import flatPickr from "vue-flatpickr-component";
import moment from "moment/moment";
import {round} from "@/utils";


export default {
  name: 'RestructuringInterestForm',
  components: {flatPickr},
  props: {
    /** @type {RestructuringInterest} */
    restructuringInterest: {type: Object, required: true}
  },
  data() {
    return {
      configDue: {
        monthSelectorType: 'static',
        allowInput: true,
        locale: Thai,
        dateFormat: 'd-m-Y',
      },
      startDate: moment().format('DD-MM-YYYY'),
      endDate: moment().format('DD-MM-YYYY'),
      numDays: 1,
      interestRate: 12,
      principalAmount: 0,
      interestAfterLawsuitDate: 0,
    }
  },
  watch: {
    startDate() {
      this.calculateInterestAfterLawsuitDate()
    },
    endDate() {
      this.calculateInterestAfterLawsuitDate()
    },
    interestRate() {
      this.calculateInterestAfterLawsuitDate()
    },
    principalAmount() {
      this.calculateInterestAfterLawsuitDate()
    }
  },
  methods: {
    calculateInterestAfterLawsuitDate() {
      if (this.startDate && this.endDate) {
        const start = moment(this.startDate, "DD-MM-YYYY")
        const end = moment(this.endDate, "DD-MM-YYYY")
        this.numDays = end.diff(start, 'days') + 1 // +1 รวมวันแรก

        // ✅ คำนวณดอกเบี้ยตามสูตร: ROUND(F2 * E2% / 365, 2) * D2
        const interestPerDay = round((this.principalAmount * (this.interestRate / 100)) / 365, 2)
        this.restructuringInterest.interestAfterLawsuitDate = interestPerDay * this.numDays
      } else {
        this.numDays = 0
        this.restructuringInterest.interestAfterLawsuitDate = 0
      }
    }
  }

}
</script>

<style scoped>
</style>
